import {Class} from "../utils";

/**
 *
 * @class DetailsHandlerDef
 *
 */

export default Class(
  {
    initialize: function (options) {
      /**
       Indicates whether the details provided should be considered an extension of the result rather than related information (Layouts may show "more" handlers at the top without specific heading)
       @name Result#more
       @type Boolean
       */
      this.more = false;
      if (options.more){
        this.more = options.more;
      }
      this.buttonText = "";
      if (options.buttonText){
        this.buttonText = options.buttonText;
      }
      this.buttonImage = "";
      if (options.buttonImage){
        this.buttonImage = options.buttonImage;
      }
      this.fullScreen = false;
      if (options.fullScreen){
        this.fullScreen = options.fullScreen;
      }
      this.description = "";
      if (options.description){
        this.description = options.description;
      }
      this.handlerFunction = ()=>{return[];};
      if (options.handler){
        this.handlerFunction = options.handler;
      }
      this.isApplicableFunction = ()=>{return true;};
      if (options.isApplicable){
        this.isApplicableFunction = options.isApplicable;
      }
    },
    
    set searchers(sCollection){
      for (var searcher of sCollection) {
        this.addSearcher(searcher);
      }
    },
    
    addSearcher(){
      //Do nothing - May be implemented in subclasses
    },

    getbuttonText: function (){
      return this.buttonText;
    },

    getbuttonImage: function (){
      return this.buttonImage;
    },
    
    handler: function(result){
      return this.handlerFunction(result);
    },
    
    isApplicable: function(result){
      return this.isApplicableFunction(result);
    },
    
    CLASS_NAME: 'Septima.Search.DetailsHandlerDef'
  }
);